﻿'use strict';

/*
Class: OpaccArticlePrice
Description: Price handling
*/

import { opaccAjaxPlugin, opaccStorePlugin } from './vendor/script/opacc.static.js';

export class OpaccArticlePrice {
    constructor() {

        this.articleAmountPerRequest = 20;
        this.buttonElementSelector = '.opc-segment-navigation .opc-button[data-op-href]';

        let articlePriceUrlWrapper = document.getElementById('article-price-url');
        if(articlePriceUrlWrapper && articlePriceUrlWrapper.hasAttribute('data-op-url') && articlePriceUrlWrapper.getAttribute('data-op-url') != '') {
            this.articlePriceUrl = articlePriceUrlWrapper.getAttribute('data-op-url');
            this.collectData();
        }
    }

    collectData() {
        this.artInternalNumbers = [];
        let artPriceWrappers = document.querySelectorAll('.article-price-wrapper[data-op-status="pending"]');
        Array.from(artPriceWrappers).forEach(artPriceWrapper => {
            if(artPriceWrapper.hasAttribute('data-op-art-internalno') && artPriceWrapper.getAttribute('data-op-art-internalno') != '') {
                this.artInternalNumbers.push(artPriceWrapper.getAttribute('data-op-art-internalno'));
                artPriceWrapper.setAttribute('data-op-status', 'loading');
            }
        });

        if(this.artInternalNumbers.length > 0) {
            this.loadPrice();
        }
    }

    loadPrice() {
        let artIntNoString = '';
        let totalCounter = 1;
        let currentCounter = 1;

        //group artinternals for multiple requests
        this.artInternalNumbers.forEach(artInternalNo => {
            if(currentCounter > 1) {
                artIntNoString += ',';
            }
            artIntNoString += String(artInternalNo);

            // group articles for requests
            if(((currentCounter % this.articleAmountPerRequest) === 0) || (totalCounter === this.artInternalNumbers.length)) {
                let data = {
                    artIntNoPrice: artIntNoString
                }
                opaccAjaxPlugin.fetchAsynPostForm(this.articlePriceUrl, data, this.showPrice.bind(this), opaccAjaxPlugin.getDefaultErrorFnc, true);
                currentCounter = 1;
                artIntNoString = '';
            } else {
                currentCounter++;
            }
            totalCounter++;
        });
    }

    showPrice(response) {
        let jsonResponse = JSON.parse(response.dataAsHtml);
        Array.from(jsonResponse.price).forEach(priceInfo => {
            let priceTargetWrappers = document.querySelectorAll('.article-price-wrapper[data-op-art-internalno="'+priceInfo.artIntNo+'"]');
            Array.from(priceTargetWrappers).forEach(priceTargetWrapper => {
                priceTargetWrapper.innerHTML = this.htmlDecode(priceInfo.text);
                let additionalevpcontainter = priceTargetWrapper.parentElement.nextElementSibling;
                if ( additionalevpcontainter) {
                    priceTargetWrapper.parentElement.nextElementSibling.innerHTML = this.htmlDecode(priceInfo.evp);
                }
                priceTargetWrapper.setAttribute('data-op-status', 'done');
            });
        });

        let resultWrapperSelector = '.result-view-wrapper';
		if (document.querySelector(resultWrapperSelector)) {
            if(document.querySelector(this.buttonElementSelector)) {
                opaccStorePlugin.set('persistentView', opaccStorePlugin.getCurrentURI(), resultWrapperSelector, this.buttonElementSelector);
            } else {
                opaccStorePlugin.set('persistentView', opaccStorePlugin.getCurrentURI(), resultWrapperSelector);
            }
        }
    }

    htmlDecode(input){
        if(!this.shadowPlaceholder) {
            this.shadowPlaceholder = document.createElement('div');
        } else {
            this.shadowPlaceholder.innerHTML = '';
        }
        this.shadowPlaceholder.innerHTML = input;
        return this.shadowPlaceholder.childNodes[0].nodeValue;
      }

}




